import type { Event } from '@patsnap/tahiti-core';

export interface CheckStatistics {
    /**
     * 问题数量
     * @description 格式化的字符串, 例如: 10,000
     */
    issues: string;
    /**
     * 扫描字数
     * @description 格式化的字符串, 例如: 10,000
     */
    scannedWord: string;
    /**
     * 耗时
     * @description 格式化的字符串, 例如: 10,000
     */
    spendTime: string;
}

/**
 * 校对统计信息服务
 */
export interface CheckStatisticsService {
    /**
     * 获取当前统计信息
     */
    getStatistics(): CheckStatistics;

    /**
     * 获取加载状态
     */
    getIsLoading(): boolean;

    /**
     * 加载统计信息
     * @param taskId 任务ID
     */
    loadStatistics(taskId: string): Promise<void>;

    /**
     * 统计信息变化事件
     */
    readonly onStatisticsChange: Event<CheckStatistics>;

    /**
     * 加载状态变化事件
     */
    readonly onLoadingChange: Event<boolean>;
}

export const CheckStatisticsService = Symbol.for('CheckStatisticsService');
